(() => {
  // Store for selected upsell variant IDs
  window.selectedUpsellVariants = window.selectedUpsellVariants || new Set();

  const formatMoney = (cents, format) => {
    // Custom formatting for $ no decimals
    const value = (cents || 0) / 100;
    // Format with commas, no decimals
    const formatted = Math.floor(value).toLocaleString("en-AU");
    return "$" + formatted;
  };

  const getSelectedVariant = () => {
    const node = document.querySelector(
      "variant-selects [data-selected-variant]"
    );
    if (!node) return null;
    try {
      return JSON.parse(node.innerHTML);
    } catch (_) {
      return null;
    }
  };

  const getSelectedSizeValue = () => {
    const inputs = document.querySelectorAll(
      'variant-selects input[name^="options["]:checked, variant-selects select[name^="options["]'
    );
    for (const el of inputs) {
      if (el.tagName === "SELECT") {
        const opt = el.selectedOptions?.[0];
        if (opt) return opt.textContent?.trim() || opt.value;
      }
      if (el.type === "radio" || el.type === "checkbox") {
        if (el.value) return el.value;
      }
    }
    return null;
  };

  const findVariantForSize = (variants, sizeOptionName, desiredSize) => {
    if (!desiredSize) return null;
    const desired = (desiredSize || "").toString().trim().toLowerCase();
    const compare = (v) => {
      const o1 = v.option1?.toString().trim().toLowerCase();
      const o2 = v.option2?.toString().trim().toLowerCase();
      const o3 = v.option3?.toString().trim().toLowerCase();
      return o1 === desired || o2 === desired || o3 === desired;
    };
    return variants.find((v) => v.available && compare(v)) || null;
  };

  const renderPrice = (root, variant, moneyFormat) => {
    const saleEl = root.querySelector("._1_price_sale");
    const rrpWrap = root.querySelector("._1_pp_ups_price_rrp_wrp");
    const rrpEl = root.querySelector("._1_price_rrp");
    if (!variant) {
      if (saleEl) saleEl.textContent = "";
      if (rrpWrap) rrpWrap.style.display = "none";
      return;
    }
    const price = Number(variant.price);
    const compareAt = Number(variant.compare_at_price);

    const priceText = formatMoney(price, moneyFormat);
    if (saleEl) saleEl.textContent = priceText;

    if (compareAt && compareAt > price) {
      if (rrpEl) rrpEl.textContent = formatMoney(compareAt, moneyFormat);
      if (rrpWrap) rrpWrap.style.display = "flex";
    } else if (rrpWrap) {
      rrpWrap.style.display = "none";
    }
  };

  const updateButtonState = (btn, isSelected, addLabel, addedLabel) => {
    if (!btn) return;
    btn.classList.toggle("active", !!isSelected);
    btn.dataset.selected = isSelected ? "true" : "false";
    const label = btn.querySelector("._1_btn_ttl");
    if (label) label.textContent = isSelected ? addedLabel : addLabel;
  };

  // Reset all upsell selections to initial state
  const resetAllUpsellSelections = () => {
    window.selectedUpsellVariants.clear();
    document.querySelectorAll("._1_pp_add_btn").forEach((btn) => {
      const box = btn.closest("._1_pp_box");
      if (!box) return;
      const addLabel = box.dataset.addLabel || "+ ADD";
      const addedLabel = box.dataset.addedLabel || "Added";
      updateButtonState(btn, false, addLabel, addedLabel);
    });
  };

  // Get all selected upsell variant IDs
  const getSelectedUpsellVariantIds = () => {
    return Array.from(window.selectedUpsellVariants);
  };

  // Expose function globally for the ATC form to use
  window.getSelectedUpsellVariantIds = getSelectedUpsellVariantIds;
  window.resetAllUpsellSelections = resetAllUpsellSelections;

  const bindUpsell = (box, moneyFormat) => {
    const data = box.dataset;
    let variants;
    try {
      variants = JSON.parse(data.variants || "[]");
    } catch (e) {
      variants = [];
    }
    const matchSize = data.matchSize === "true";
    const sizeOption = data.sizeOption || "Size";
    const addLabel = data.addLabel || "+ ADD";
    const addedLabel = data.addedLabel || "Added";

    const btn = box.querySelector("._1_pp_add_btn");
    const learnMoreLink = box.querySelector("._1_pp_ups_info_wrp a");

    const wrapper = box.closest("#product-upsell-wrapper-additive");
    const updateWrapperVisibility = () => {
      if (!wrapper) return;
      const boxes = wrapper.querySelectorAll("._1_pp_box");
      const anyVisible = Array.from(boxes).some(
        (b) => (b.style.display || "") !== "none"
      );
      wrapper.style.display = anyVisible ? "" : "none";
    };

    const pickVariant = () => {
      if (!variants.length) return null;
      if (!matchSize) return variants.find((v) => v.available) || null;
      const selected = getSelectedVariant();
      const desiredSize =
        getSelectedSizeValue() ||
        selected?.option1 ||
        selected?.option2 ||
        selected?.option3;
      const matched = findVariantForSize(variants, sizeOption, desiredSize);
      return matched || null;
    };

    const applyVariant = (variant, resetSelection = true) => {
      if (!variant) {
        box.style.display = "none";
        updateWrapperVisibility();
        return;
      }
      box.style.display = "flex";
      renderPrice(box, variant, moneyFormat);
      if (btn) {
        // Remove old variant from selection if it was selected
        const oldVariantId = btn.dataset.variationId;
        if (oldVariantId && window.selectedUpsellVariants.has(oldVariantId)) {
          window.selectedUpsellVariants.delete(oldVariantId);
        }
        btn.dataset.variationId = variant.id;
        // Reset button state when variant changes (size change)
        if (resetSelection) {
          updateButtonState(btn, false, addLabel, addedLabel);
        }
      }
      if (learnMoreLink && data.learnMoreUrl) {
        learnMoreLink.href = data.learnMoreUrl;
      }
      updateWrapperVisibility();
    };

    const reapply = () => {
      // Reset selection when size changes
      applyVariant(pickVariant(), true);
    };

    applyVariant(pickVariant(), true);

    // Toggle selection on click instead of adding to cart
    btn?.addEventListener("click", (e) => {
      e.preventDefault();
      e.stopPropagation();

      const variantId = btn.dataset.variationId;
      if (!variantId) return;

      const isCurrentlySelected = btn.dataset.selected === "true";

      if (isCurrentlySelected) {
        // Deselect
        window.selectedUpsellVariants.delete(variantId);
        updateButtonState(btn, false, addLabel, addedLabel);
      } else {
        // Select
        window.selectedUpsellVariants.add(variantId);
        updateButtonState(btn, true, addLabel, addedLabel);
      }
    });

    // Re-run on variant change events (this resets selections)
    document.addEventListener("variant:change", reapply);

    // Listen for size dropdown changes specifically
    document
      .querySelectorAll(
        'variant-selects input[name^="options["], variant-selects select[name^="options["], select[id^="Size-Select-"]'
      )
      .forEach((el) => {
        el.addEventListener("change", () => {
          // Reset all upsell selections when main product size changes
          resetAllUpsellSelections();
          reapply();
        });
      });
  };

  const init = () => {
    const moneyFormat = window.Shopify?.currency?.active
      ? undefined
      : undefined;
    document
      .querySelectorAll("._1_pp_box[data-variants]")
      .forEach((box) => bindUpsell(box, moneyFormat));

    // Override the product-form submit to include upsells
    overrideProductFormSubmit();
  };

  // Override the product-form submit handler to include selected upsells
  const overrideProductFormSubmit = () => {
    const productForms = document.querySelectorAll("product-form");

    productForms.forEach((productForm) => {
      const form = productForm.querySelector(
        'form[data-type="add-to-cart-form"]'
      );
      if (!form) return;

      // Remove the existing submit listener by cloning and replacing
      const newForm = form.cloneNode(true);
      form.parentNode.replaceChild(newForm, form);

      // Add our custom submit handler
      newForm.addEventListener("submit", async (evt) => {
        evt.preventDefault();

        const submitButton = productForm.querySelector('[type="submit"]');
        const spinner = productForm.querySelector(".loading__spinner");
        const cart =
          document.querySelector("cart-notification") ||
          document.querySelector("cart-drawer");

        if (submitButton?.getAttribute("aria-disabled") === "true") return;

        // Show loading state
        if (submitButton) {
          submitButton.setAttribute("aria-disabled", "true");
          submitButton.classList.add("loading");
        }
        if (spinner) spinner.classList.remove("hidden");

        try {
          // Get the current variant ID - priority order:
          // 1. Custom size dropdown selected option variant id
          // 2. Foundation custom size dropdown
          // 3. Form hidden input
          // 4. variant-selects fallback
          let mainVariantId = null;

          const customSizeSelect = document.querySelector(
            'select[id^="Size-Select-"]'
          );
          const customSizeSelectedOption =
            customSizeSelect?.options[customSizeSelect.selectedIndex];
          const customSizeVariantId =
            customSizeSelectedOption?.getAttribute("data-variant-id");

          if (customSizeVariantId && /^\d+$/.test(customSizeVariantId)) {
            mainVariantId = customSizeVariantId;
          }

          // Foundation pages use a custom size dropdown whose value is the
          // selected variant id, so prefer it over the default form input.
          const foundationSizeSelect = document.querySelector(
            ".foundation-size-select"
          );
          const foundationSelectedOption =
            foundationSizeSelect?.options[foundationSizeSelect.selectedIndex];

          if (
            !mainVariantId &&
            foundationSizeSelect &&
            foundationSelectedOption &&
            !foundationSelectedOption.disabled &&
            /^\d+$/.test(foundationSizeSelect.value)
          ) {
            mainVariantId = foundationSizeSelect.value;
          }

          // Try to get from form input if no Foundation selection exists
          if (!mainVariantId) {
            const originalInput = productForm.querySelector('input[name="id"]');
            mainVariantId =
              originalInput?.value ||
              newForm.querySelector('[name="id"]')?.value;
          }

          // If input extraction failed, try variant-selects data
          if (!mainVariantId) {
            const selectedVariantData = getSelectedVariant();
            if (selectedVariantData && selectedVariantData.id) {
              mainVariantId = selectedVariantData.id;
            }
          }
          const items = [];

          if (mainVariantId) {
            items.push({ id: parseInt(mainVariantId), quantity: 1 });
          }

          // Add selected upsell variants
          const upsellIds = window.getSelectedUpsellVariantIds
            ? window.getSelectedUpsellVariantIds()
            : [];
          upsellIds.forEach((id) => {
            items.push({ id: parseInt(id), quantity: 1 });
          });

          if (items.length === 0) return;

          // Prepare sections for cart drawer update
          const sectionsToRender = cart
            ? cart.getSectionsToRender().map((section) => section.id)
            : [];

          const response = await fetch(
            window.Shopify.routes.root + "cart/add.js",
            {
              method: "POST",
              headers: {
                "Content-Type": "application/json",
                Accept: "application/json",
                "X-Requested-With": "XMLHttpRequest",
              },
              body: JSON.stringify({
                items: items,
                sections: sectionsToRender,
                sections_url: window.location.pathname,
              }),
            }
          );

          const data = await response.json();

          if (data.status) {
            // Error occurred
            console.error(
              "Add to cart error:",
              data.description || data.message
            );
            return;
          }

          // Reset upsell selections after successful add
          if (window.resetAllUpsellSelections) {
            window.resetAllUpsellSelections();
          }

          // Update cart drawer and open it
          if (cart) {
            if (cart.setActiveElement) {
              cart.setActiveElement(document.activeElement);
            }
            // Always fetch fresh cart drawer content since /cart/add.js with items array
            // doesn't return sections in the expected format for renderContents
            try {
              const cartResponse = await fetch(
                `${window.Shopify.routes.root}cart?section_id=cart-drawer`
              );
              const cartHtml = await cartResponse.text();
              const cartDoc = new DOMParser().parseFromString(
                cartHtml,
                "text/html"
              );
              const cartDrawerContent = cartDoc.querySelector("#CartDrawer");
              const targetDrawer = document.querySelector("#CartDrawer");
              if (targetDrawer && cartDrawerContent) {
                targetDrawer.innerHTML = cartDrawerContent.innerHTML;
              }
              // Remove is-empty class from cart-drawer since we just added items
              if (cart.classList.contains("is-empty")) {
                cart.classList.remove("is-empty");
              }
              // Also update cart icon bubble
              const bubbleResponse = await fetch(
                `${window.Shopify.routes.root}cart?section_id=cart-icon-bubble`
              );
              const bubbleHtml = await bubbleResponse.text();
              const bubbleDoc = new DOMParser().parseFromString(
                bubbleHtml,
                "text/html"
              );
              const bubbleContent = bubbleDoc.querySelector(".shopify-section");
              const bubbleTarget = document.getElementById("cart-icon-bubble");
              if (bubbleTarget && bubbleContent) {
                bubbleTarget.innerHTML = bubbleContent.innerHTML;
              }
              // Open the cart drawer
              if (cart.open) {
                cart.open();
              }
            } catch (fetchError) {
              console.error("Error fetching cart drawer:", fetchError);
              // Fallback: just open the drawer with existing content
              if (cart.open) {
                cart.open();
              }
            }
          } else {
            // Fallback: redirect to cart page if no drawer
            window.location = window.Shopify.routes.root + "cart";
          }

          // Publish cart update event if available
          if (
            typeof publish !== "undefined" &&
            typeof PUB_SUB_EVENTS !== "undefined"
          ) {
            publish(PUB_SUB_EVENTS.cartUpdate, {
              source: "product-form",
              productVariantId: mainVariantId,
              cartData: data,
            });
          }
        } catch (error) {
          console.error("Add to cart failed:", error);
        } finally {
          // Reset loading state
          if (submitButton) {
            submitButton.classList.remove("loading");
            submitButton.removeAttribute("aria-disabled");
          }
          if (spinner) spinner.classList.add("hidden");
        }
      });
    });
  };

  document.addEventListener("DOMContentLoaded", init);

  // Hook into Dawn pub-sub if available
  if (
    typeof subscribe !== "undefined" &&
    typeof PUB_SUB_EVENTS !== "undefined"
  ) {
    subscribe(PUB_SUB_EVENTS.variantChange, () => {
      document.dispatchEvent(new CustomEvent("variant:change"));
    });
  }
})();
